import { isUiSettingUpdated } from "../../../../domain/uiSetting/model/uiSettingUpdated";
import { fromDomain } from "./storageUiSettings";
const storageUiSettingsUpdate = ({ storage }) => async (aggregateRoot) => {
    const { domainEvents, aggregateId } = aggregateRoot;
    const uiSettingUpdated = domainEvents.find(isUiSettingUpdated);
    if (!uiSettingUpdated) {
        return;
    }
    await storage.write(aggregateId, fromDomain(aggregateRoot));
};
export { storageUiSettingsUpdate };
